import { render, staticRenderFns } from "./PolymerTypeFilter.vue?vue&type=template&id=388c1945&"
import script from "./PolymerTypeFilter.vue?vue&type=script&lang=js&"
export * from "./PolymerTypeFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports